import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/content";

export default function Showcase() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["10%", "-10%"]);

  return (
    <section
      data-testid="showcase"
      className="relative bg-[#070707] py-28 md:py-40 overflow-hidden"
    >
      <div ref={ref} className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Large winter spotlight */}
          <div className="lg:col-span-7 relative">
            <motion.div style={{ y: y1 }} className="gold-border p-3 will-change-transform">
              <img
                src={IMAGES.facadeWinter}
                alt="Sarrgosa residences glowing warm on a snow-covered Kasauli evening"
                className="w-full h-[420px] md:h-[640px] object-cover object-top spotlight"
              />
            </motion.div>
            <span className="absolute -top-6 left-4 vertical-rl text-[10px] tracking-luxe uppercase text-[#d4af37]/60 hidden md:block">
              Winter · Elevation 5,800 ft
            </span>
          </div>

          {/* Text + small frame */}
          <div className="lg:col-span-5 lg:pl-6">
            <Reveal>
              <span className="text-xs tracking-luxe uppercase text-[#d4af37]">
                The Architecture
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-lux text-4xl md:text-5xl mt-6 leading-[1.08] text-[#f5f5f0]">
                Stone, timber and glass —
                <span className="italic gold-gradient-text"> honestly made.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-[#9a968c] leading-relaxed">
                Gabled roofs echo the ridgeline. Locally quarried stone grounds
                each tower, while floor-to-ceiling glass pulls the forest
                indoors. Warm interior light, framed by golden linework, turns
                every facade into a lantern on the hillside.
              </p>
            </Reveal>

            <motion.div style={{ y: y2 }} className="mt-10 gold-border p-3 will-change-transform">
              <img
                src={IMAGES.studioInterior}
                alt="Sarrgosa studio apartment interior with floor-to-ceiling glass overlooking the misty hills"
                className="w-full h-[240px] object-cover spotlight"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
